"use strict";
"use es6"; // typeof any so that it we don't have to cast when comparing a result to the error object

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorObject = void 0;
var errorObject = {
  e: {}
};
exports.errorObject = errorObject;